import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout, updateUser } from "../redux/features/authSlice";
import { getToken, getUserDetails } from "../resources/helper/helper";
import { toast } from "react-toastify";
import { CircularProgress } from "@mui/material";
import { getAllOrders } from "../redux/features/orderSlice";

export default function UserDashboard() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading } = useSelector((state) => state.auth);
  const { orders } = useSelector((state) => state.order);
  const [userDetails, setUserDetails] = useState(null);
  const [credentials, setCredentials] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    displayName: "",
  });
  const token = getToken();

  useEffect(() => {
    if (token) {
      dispatch(getAllOrders(token))
        .unwrap()
        .then((res) => {
          console.log("Orders res", res);
        })
        .catch((err) => {
          console.log("Error", err);
        });
    }
  }, []);
  useEffect(() => {
    const data = getUserDetails();
    setUserDetails(data);
  }, []);

  useEffect(() => {
    if (userDetails) {
      setCredentials({ ...userDetails, phone: userDetails.phoneNumber });
    }
  }, [userDetails]);

  const handleInputChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };

  const handleLogout = () => {
    dispatch(logout());
    navigate("/login");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { firstName, lastName, displayName } = credentials;
    const userInfo = { firstName, lastName, displayName };
    const token = getToken();
    const payload = {
      user: { ...userInfo },
      token,
    };
    dispatch(updateUser(payload))
      .unwrap()
      .then((res) => {
        toast.success("User info updated successfully", {
          position: "top-center",
          theme: "colored",
        });
        console.log("User info updated successfully", res);
      })
      .catch((err) => {
        toast.error(err, {
          position: "top-center",
          theme: "colored",
        });
        console.error("Error updating user info:", err);
      });
  };

  return (
    <div>
      <main className="main pages">
        <div className="page-header breadcrumb-wrap">
          <div className="container">
            <div className="breadcrumb">
              <a rel="nofollow">
                <i className="fi-rs-home mr-5" />
                Home
              </a>
              <span /> Login <span /> My Account
            </div>
          </div>
        </div>
        <div className="page-content pt-150 pb-150">
          <div className="container">
            <div className="row">
              <div className="col-lg-10 m-auto">
                <div className="row">
                  <div className="col-md-3">
                    <div className="dashboard-menu">
                      <ul className="nav flex-column" role="tablist">
                        <li className="nav-item">
                          <a
                            className="nav-link active"
                            id="dashboard-tab"
                            data-bs-toggle="tab"
                            role="tab"
                            href="#dashboard"
                            aria-controls="dashboard"
                            aria-selected="false"
                          >
                            <i className="fi-rs-settings-sliders mr-10" />
                            Dashboard
                          </a>
                        </li>
                        <li className="nav-item">
                          <a
                            className="nav-link"
                            id="orders-tab"
                            data-bs-toggle="tab"
                            role="tab"
                            href="#orders"
                            aria-controls="orders"
                            aria-selected="false"
                          >
                            <i className="fi-rs-shopping-bag mr-10" />
                            Orders History
                          </a>
                        </li>
                        <li className="nav-item">
                          <a
                            className="nav-link"
                            id="account-detail-tab"
                            data-bs-toggle="tab"
                            href="#account-detail"
                            role="tab"
                            aria-controls="account-detail"
                            aria-selected="true"
                          >
                            <i className="fi-rs-user mr-10" />
                            Account details
                          </a>
                        </li>
                        <li className="nav-item" onClick={handleLogout}>
                          <a className="nav-link">
                            <i className="fi-rs-sign-out mr-10" />
                            Logout
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-md-9">
                    <div className="tab-content account dashboard-content pl-50">
                      <div
                        className="tab-pane fade active show"
                        id="dashboard"
                        role="tabpanel"
                        aria-labelledby="dashboard-tab"
                      >
                        <div className="card">
                          <div className="card-header">
                            <h3 className="mb-0">
                              Hello{" "}
                              {userDetails?.firstName
                                ? userDetails?.firstName
                                : "Rosie!"}
                            </h3>
                          </div>
                          <div className="card-body">
                            <p>
                              From your account dashboard. you can easily check
                              &amp; view your <a>recent orders</a>,
                              <br />
                              manage your
                              <a>shipping and billing addresses</a> and
                              <a>edit your password and account details.</a>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div
                        className="tab-pane fade"
                        id="orders"
                        role="tabpanel"
                        aria-labelledby="orders-tab"
                      >
                        <div className="card">
                          <div className="card-header">
                            <h3 className="mb-0">Your Orders</h3>
                          </div>
                          <div
                            style={{
                              minHeight: "100px",
                              maxHeight: "500px",
                              overflow: "auto",
                            }}
                            className="card-body"
                          >
                            <div className="table-responsive">
                              <table className="table">
                                <thead>
                                  <tr>
                                    <th>Order</th>
                                    <th>Date</th>
                                    <th>Status</th>
                                    <th>Total</th>
                                    <th>Items</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {orders && orders?.length > 0 ? (
                                    orders?.map((item) => (
                                      <tr>
                                        <td>{item?._id}</td>
                                        <td>{item?.createdAt?.slice(0, 10)}</td>

                                        <td>{item?.orderStatus}</td>
                                        <td>Rs. {item?.total}</td>
                                        <td>{item?.productIds?.length}</td>
                                      </tr>
                                    ))
                                  ) : (
                                    <>No Order Found</>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="tab-pane fade"
                        id="track-orders"
                        role="tabpanel"
                        aria-labelledby="track-orders-tab"
                      >
                        <div className="card">
                          <div className="card-header">
                            <h3 className="mb-0">Orders tracking</h3>
                          </div>
                          <div className="card-body contact-from-area">
                            <p>
                              To track your order please enter your OrderID in
                              the box below and press "Track" button. This was
                              given to you on your receipt and in the
                              confirmation email you should have received.
                            </p>
                            <div className="row">
                              <div className="col-lg-8">
                                <form
                                  className="contact-form-style mt-30 mb-50"
                                  action="#"
                                  method="post"
                                >
                                  <div className="input-style mb-20">
                                    <label>Order ID</label>
                                    <input
                                      name="order-id"
                                      placeholder="Found in your order confirmation email"
                                      type="text"
                                    />
                                  </div>
                                  <div className="input-style mb-20">
                                    <label>Billing email</label>
                                    <input
                                      name="billing-email"
                                      placeholder="Email you used during checkout"
                                      type="email"
                                    />
                                  </div>
                                  <button
                                    className="submit submit-auto-width"
                                    type="submit"
                                  >
                                    Track
                                  </button>
                                </form>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="tab-pane fade"
                        id="address"
                        role="tabpanel"
                        aria-labelledby="address-tab"
                      >
                        <div className="row">
                          <div className="col-lg-6">
                            <div className="card mb-3 mb-lg-0">
                              <div className="card-header">
                                <h3 className="mb-0">Billing Address</h3>
                              </div>
                              <div className="card-body">
                                <address>
                                  3522 Interstate
                                  <br />
                                  75 Business Spur,
                                  <br />
                                  Sault Ste. <br />
                                  Marie, MI 49783
                                </address>
                                <p>New York</p>
                                <a className="btn-small">Edit</a>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="card">
                              <div className="card-header">
                                <h5 className="mb-0">Shipping Address</h5>
                              </div>
                              <div className="card-body">
                                <address>
                                  4299 Express Lane
                                  <br />
                                  Sarasota, <br />
                                  FL 34249 USA <br />
                                  Phone: 1.941.227.4444
                                </address>
                                <p>Sarasota</p>
                                <a className="btn-small">Edit</a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="tab-pane fade"
                        id="account-detail"
                        role="tabpanel"
                        aria-labelledby="account-detail-tab"
                      >
                        <div className="card">
                          <div className="card-header">
                            <h3>Account Details</h3>
                          </div>
                          <div className="card-body">
                            <form>
                              <div className="row">
                                <div className="form-group col-md-6">
                                  <label>
                                    First Name
                                    <span className="required">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    required
                                    name="firstName"
                                    placeholder="First Name"
                                    value={credentials.firstName}
                                    onChange={handleInputChange}
                                  />
                                </div>
                                <div className="form-group col-md-6">
                                  <label>
                                    Last Name
                                    <span className="required">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    required
                                    name="lastName"
                                    placeholder="Last Name"
                                    value={credentials.lastName}
                                    onChange={handleInputChange}
                                  />
                                </div>
                                <div className="form-group col-md-12">
                                  <label>
                                    Display Name
                                    <span className="required">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    required
                                    name="displayName"
                                    placeholder="Display Name"
                                    value={credentials.displayName}
                                    onChange={handleInputChange}
                                  />
                                </div>
                                <div className="form-group col-md-12">
                                  <label>
                                    Email Address
                                    <span className="required">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    name="email"
                                    disabled
                                    placeholder="Email"
                                    value={credentials.email}
                                    onChange={handleInputChange}
                                  />
                                </div>
                                <div className="form-group col-md-12">
                                  <label>
                                    Phone Number
                                    <span className="required">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    disabled
                                    name="phone"
                                    value={credentials.phone}
                                    onChange={handleInputChange}
                                    placeholder="Phone Number"
                                  />
                                </div>
                                <div
                                  className="col-md-12"
                                  style={{
                                    marginTop: "10px",
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "center",
                                  }}
                                >
                                  <button
                                    className="btn btn-fill-out submit font-weight-bold"
                                    name="submit"
                                    value="Submit"
                                    style={{ width: "50%" }}
                                    onClick={handleSubmit}
                                  >
                                    {loading ? (
                                      <CircularProgress
                                        size={20}
                                        color="inherit"
                                      />
                                    ) : (
                                      "Save Change"
                                    )}
                                  </button>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
